
import { useEffect } from 'react';
import { intelligentNotificationService } from '@/services/notifications/intelligentNotificationService';

export const useIntelligentNotifications = () => {
  useEffect(() => {
    // Désactiver temporairement le service de notifications intelligentes
    // pour éviter les timeouts d'inactivité
    console.log('📱 [Intelligent Notifications] Service désactivé temporairement');
    
    return () => {
      // Nettoyer les ressources si nécessaire
      intelligentNotificationService.cleanup();
    };
  }, []);

  // Méthodes compatibles avec l'interface attendue
  const updateContext = () => {};
  const checkNotifications = () => {};
  const scheduleNotification = (id: string, delay: number, callback: () => void) => {
    // Fonction vide pour maintenir la compatibilité
    console.log('📱 [Notifications] Scheduled notification disabled:', id);
  };

  return {
    updateContext,
    checkNotifications,
    scheduleNotification,
  };
};
